exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vw-small[data-v-40cfe2a5] {\n  font-size: 0.8rem;\n}\n", ""]);

// exports
